import { StyleSheet } from 'react-native';
import { pageContainerStyle } from '../../common.style';

export default StyleSheet.create({
  container: {
    ...pageContainerStyle,
    backgroundColor: '#FFF',
  },
  scrollContent: {
    paddingHorizontal: 16,
    gap: 10,
  },

  sectionTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: '#A0A6B8',
    marginBottom: 10,
    marginTop: 8,
    letterSpacing: 0.8,
  },
  list: {
    //marginBottom: 18,
    gap: 10,
  },
  menuCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    paddingVertical: 14,
    paddingHorizontal: 14,   
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 1,    
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  menuText: {
    flex: 1,
  },
  menuTitle: {
    fontSize: 15,
    fontWeight: '600',
    color: '#151A2D',
  },
  menuSubtitle: {
    marginTop: 2,
    fontSize: 12,
    color: '#8A90A6',
  },
  dangerText: {
    color: '#D64545',
  },
    initialsAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    backgroundColor: '#6366F1',
  },
  initialsAvatarText: {


    color: '#fff',
    fontWeight: '700',
    fontSize: 15,
  },
});